import { c as _c } from "react-compiler-runtime";
import { registerQuery, useQuery } from 'data-fetching-client';
import userInfoHubHttp from 'hub-http/userInfo';
const buildAccessCheck = (validKeys, keys) => {
  const knownKeys = new Set(validKeys);
  const result = new Set();
  for (const key of keys) {
    if (knownKeys.has(key)) {
      result.add(key);
    }
  }
  return result;
};
const COLLABORATION_SIDEBAR_GATES = [];
const SCOPES_FOR_SUPPORTED_HUBS = {
  MARKETING_HUB: 'commenting-access-marketing-hub',
  SERVICE_HUB: 'commenting-access-service-hub',
  CMS_HUB: 'commenting-access-cms-hub',
  OPS_HUB: 'commenting-access-ops-hub',
  SALES_HUB: 'commenting-access-sales-hub'
};
const COLLABORATION_SIDEBAR_SCOPES = ['ads-read', 'blog-write', 'calendar-access', 'campaigns-access', 'campaigns-write', 'commenting-access-cms-hub', 'commenting-access-marketing-hub', 'commenting-access-ops-hub', 'commenting-access-sales-hub', 'commenting-access-service-hub', 'email-write', 'landingpages-write', 'marketing-tasks-write', 'pages-write', 'teams-advanced-modeling-access'];
const USER_INFO_QUERY = registerQuery({
  args: [],
  fieldName: 'collaborationSidebarUserInfo',
  fetcher: async () => {
    const userInfoResponse = await userInfoHubHttp();
    return Object.assign({}, userInfoResponse, {
      gatesForUser: buildAccessCheck(COLLABORATION_SIDEBAR_GATES, userInfoResponse.gates || []),
      scopesForUser: buildAccessCheck(COLLABORATION_SIDEBAR_SCOPES, userInfoResponse.user.scopes)
    });
  }
});
export const useUserInfo = () => {
  "use memo";

  var _data$collaborationSi, _data$collaborationSi5;
  const $ = _c(13);
  const {
    data,
    loading: userInfoLoading,
    error: userInfoError
  } = useQuery(USER_INFO_QUERY);
  let t0;
  if ($[0] !== (data === null || data === void 0 || (_data$collaborationSi = data.collaborationSidebarUserInfo) === null || _data$collaborationSi === void 0 ? void 0 : _data$collaborationSi.gatesForUser)) {
    var _data$collaborationSi4;
    t0 = gateToCheck => {
      var _data$collaborationSi2, _data$collaborationSi3;
      return (_data$collaborationSi2 = data === null || data === void 0 || (_data$collaborationSi3 = data.collaborationSidebarUserInfo) === null || _data$collaborationSi3 === void 0 ? void 0 : _data$collaborationSi3.gatesForUser.has(gateToCheck)) !== null && _data$collaborationSi2 !== void 0 ? _data$collaborationSi2 : false;
    };
    $[0] = data === null || data === void 0 || (_data$collaborationSi4 = data.collaborationSidebarUserInfo) === null || _data$collaborationSi4 === void 0 ? void 0 : _data$collaborationSi4.gatesForUser;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const hasGate = t0;
  let t1;
  if ($[2] !== (data === null || data === void 0 || (_data$collaborationSi5 = data.collaborationSidebarUserInfo) === null || _data$collaborationSi5 === void 0 ? void 0 : _data$collaborationSi5.scopesForUser)) {
    var _data$collaborationSi8;
    t1 = scopeToCheck => {
      var _data$collaborationSi6, _data$collaborationSi7;
      return (_data$collaborationSi6 = data === null || data === void 0 || (_data$collaborationSi7 = data.collaborationSidebarUserInfo) === null || _data$collaborationSi7 === void 0 ? void 0 : _data$collaborationSi7.scopesForUser.has(scopeToCheck)) !== null && _data$collaborationSi6 !== void 0 ? _data$collaborationSi6 : false;
    };
    $[2] = data === null || data === void 0 || (_data$collaborationSi8 = data.collaborationSidebarUserInfo) === null || _data$collaborationSi8 === void 0 ? void 0 : _data$collaborationSi8.scopesForUser;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const hasScope = t1;
  let t2;
  if ($[4] !== hasScope) {
    t2 = hub => hasScope(SCOPES_FOR_SUPPORTED_HUBS[hub]);
    $[4] = hasScope;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const hasScopeForHub = t2;
  const t3 = data === null || data === void 0 ? void 0 : data.collaborationSidebarUserInfo;
  let t4;
  if ($[6] !== hasGate || $[7] !== hasScope || $[8] !== hasScopeForHub || $[9] !== t3 || $[10] !== userInfoError || $[11] !== userInfoLoading) {
    t4 = {
      userInfo: t3,
      userInfoLoading,
      userInfoError,
      hasGate,
      hasScope,
      hasScopeForHub
    };
    $[6] = hasGate;
    $[7] = hasScope;
    $[8] = hasScopeForHub;
    $[9] = t3;
    $[10] = userInfoError;
    $[11] = userInfoLoading;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};